import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { LineaAccionService } from '../../../services/linea-accion.service';
import { ModalService } from '../../../../../services/modal.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { AlertService } from '../../../../../services/alert.service';
import { IndicadoresService } from '../../../services/indicadores.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EstrategiaObjetivoService } from '../../../services/estrategia-objetivo.service';
import { ObjetivoService } from '../../../services/objetivo.service';
import { EstrategiasService } from '../../../services/estrategias.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../../services/participante.elemento.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { ConfiguracionIndicadoresService } from '../../../services/configuracion-indicadores.service';

@Component({
  selector: 'app-indicadores-linea-accion',
  templateUrl: './indicadores-linea-accion.component.html',
  styleUrls: ['./indicadores-linea-accion.component.css']
})
export class IndicadoresLineaAccionComponent {
  public formLineaAccionIndicadores: UntypedFormGroup;
  public submitted = false;
  public dataLineaAccionIndicadores: any = [];
  public dataLineaAccion: any = [];
  public dataObjetivo!: any;// trae data de objetivos
  public dataEstrategiaObjetivo: any = [];// trae data catalogo comun tipo de proyecto
  public dataEquipoGerencial!: any;
  public dataParticipanteElem!: any;
  public idTipoParticipante: number = 271;
  public dataTipoParticipante!: any;
  public dataIndicadoresLineas: any = [];
  public dataEstrategias: any = [];
  public desripcionLineaAccion: any = [];
  public dataTipoParticpacion: any = [];
  public dataElementosParticpantes: any = [];
  private idDeleteRegister: number = 0;
  private idSprPlanAnio: number = 0;
  private currentUser!: any;
  public dataIndicadores: any[] = [];
  private ipAddress!: string;
  private buffer!: any;
  public nameApp = 'INDICADOR-LINEA ACCIÓN';
  public nameModal: string = 'linea-modalNewEdit'
  public selectItems: any = [];
  public dataResponsableProceso: any = [];
  public modalAdversoLinea: string = 'modalAdversoLineaA'
  public dataIndicadorSendConfig = [];
  public descripcionIndicador !: any;
  public idSprAmbiente: number = 0;
  public nombreLineaAccion = [];
  idSprTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE;
  public idResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;
  public planAnioSeleccionadoRedux: any = null;
  public dataObjetivosPorAnio: any = null;
  public dataInidcadorConfig: any[] = []
  public lineaAccion: any = null;
  public estadoActivo: number = 1;
  public idSprNivel: number = 0;
 

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @Input() set init2(lineaAccion: any) {
    this.lineaAccion = lineaAccion;
    this.initApp(lineaAccion);
  }

  @Input() set idsObjetivos(dataObjetivosPorAnio: any) {
    this.dataObjetivosPorAnio = dataObjetivosPorAnio;
  }

  @Input() set planAnual(planAnioSeleccionadoRedux: any) {
    this.planAnioSeleccionadoRedux = planAnioSeleccionadoRedux;
  }
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    public modal: ModalService,
    private indicadorService: IndicadoresService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private lineaAccionService: LineaAccionService,
    private estrategiaObjetivosService: EstrategiaObjetivoService,
    private objetivoService: ObjetivoService,
    private estrategiasService: EstrategiasService,
    private comunService: ComunService,
    private equipoGerencialService: EquipoGerencialService,
    public store: Store<AppState>,
    private participanteElementoService: ParticipanteElementoService,
    private configuracionIndicadoresService: ConfiguracionIndicadoresService,
  ) {

    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe(response => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
      this.fechaIniciObjetivo = response.planAniosSeleccionado.fechaInicio
      this.fechaFinObjetivo = response.planAniosSeleccionado.fechaFin
      this.getIpPublic();
      this.setFormLineaAccion();
    })
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  setFormLineaAccion(idSprLineaAccion: string = " ") {
    this.formLineaAccionIndicadores = this.fb.group({
      idSprLineaAccion: [idSprLineaAccion],
      idSprIndicador: [],
      idSprEquipoGerencialAnterior: ['', []],
      idSprParticipanteElemento: ['', []],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: [],
      unidadInformacion: [],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      estado: ['', [Validators.required]],
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  ngOnChanges(): void {
    this.initApp(this.lineaAccion)
  }


  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  initApp(data: string = '') {
    if (data == 'lineaAccion') {
      this.store.select('globalApp').subscribe(response => {
        this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
        this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
        this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
        this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
        this.getDataObjetivos();
      })
      this.getDataObjetivos();
    }
  }

  getDataObjetivos() {
    forkJoin([
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbiente}&idSprPlanAnio=${this.idSprPlanAnio}&estado=${this.estadoActivo}`),
      this.estrategiaObjetivosService.list(),
      this.estrategiasService.list(),
      this.lineaAccionService.list('?estado=' + this.estadoActivo),
      this.indicadorService.list(),
      this.participanteElementoService.list('?estado=1'),
      this.equipoGerencialService.list('?idSprAmbiente=' + this.idSprAmbiente),
      this.comunService.list("?spr_idSprComun=" + this.idSprTipoParticipante)
    ]).pipe(map(
      ([objetivos, estrategiasObjetivos, estrategias, lineasAccion, indicadores, participaElemento, dataEquipoGerencial, respTipoParticipa]) => {
        this.dataObjetivo = objetivos;
        this.dataEstrategiaObjetivo = estrategiasObjetivos;
        this.dataEstrategias = estrategias;
        this.dataLineaAccion = lineasAccion;
        this.dataIndicadores = indicadores;
        this.dataElementosParticpantes = participaElemento;
        this.dataEquipoGerencial = dataEquipoGerencial;
        this.dataTipoParticpacion = respTipoParticipa;
        this.mapeoLineasAccionIndicadores();
        //this.mapeoProcesosParticipante();
        this.mapeoEquipoGerencialTipoParticipa();
      })).subscribe();
  }


  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];
    for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
      for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
        if (this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun && this.dataEquipoGerencial[i].estado == 1 && this.dataEquipoGerencial[i].idSprTipoParticipante == this.idResponsable) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            participacion: this.dataTipoParticpacion[j].nombre
          })
        }
      }
    }
    this.dataResponsableProceso = dataProcess;
  }

  mapeoLineasAccionIndicadores() {
    let dataProcess: any = [];
    let dataIndicador: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataEstrategiaObjetivo.length; j++) {
        if ((this.dataObjetivo[i].idSprObjetivo == this.dataEstrategiaObjetivo[j].idSprObjetivo)) {
          for (let l = 0; l < this.dataEstrategias.length; l++) {
            if (this.dataEstrategiaObjetivo[j].idSprEstrategia == this.dataEstrategias[l].idSprEstrategia && this.dataEstrategiaObjetivo[j].nivelSuperior == 'N') {
              for (let k = 0; k < this.dataLineaAccion.length; k++) {
                if (this.dataLineaAccion[k].idSprEstrategia == this.dataEstrategias[l].idSprEstrategia) {
                  for (let m = 0; m < this.dataIndicadores.length; m++) {
                    if (this.dataIndicadores[m].idSprLineaAccion == this.dataLineaAccion[k].idSprLineaAccion) {

                      dataIndicador.push({
                        idSprIndicador: this.dataIndicadores[m].idSprIndicador,
                        idSprLineaAccion: this.dataIndicadores[m].idSprLineaAccion,
                        nombre: this.dataIndicadores[m].nombre,
                        descripcion: this.dataIndicadores[m].descripcion,
                        unidadInformacion: this.dataIndicadores[m].unidadInformacion,
                        fechaInicio: this.dataIndicadores[m].fechaInicio,
                        estado: this.dataIndicadores[m].estado,
                        idSprResponsable: this.dataIndicadores[m].idSprResponsable
                      })
                    }
                  }
                  dataProcess.push({
                    idSprLineaAccion: this.dataLineaAccion[k].idSprLineaAccion,
                    nombreLineaAccion: this.dataLineaAccion[k].nombre,
                    descripcion: this.dataLineaAccion[k].descripcion,
                    alcance: this.dataLineaAccion[k].alcance,
                    localidadImpacto: this.dataLineaAccion[k].localidadImpacto,
                    justificacion: this.dataLineaAccion[k].justificacion,
                    fechaInicio: this.dataLineaAccion[k].fechaInicio,
                    fechaFin: this.dataLineaAccion[k].fechaFin,
                    indicadores: dataIndicador
                  });
                  dataIndicador = [];
                }
              }
            }
          }
        }
      }
    }
    this.dataIndicadoresLineas = dataProcess;
  }

  onSubmit() {
    this.submitted = true;
    this.formLineaAccionIndicadores.value.usuario = this.currentUser.idSprUsuario;
    this.formLineaAccionIndicadores.value.ip = this.ipAddress;
    this.formLineaAccionIndicadores.value.idSprResponsable = this.formLineaAccionIndicadores.value.idSprEquipoGerencial;
    if (!this.formLineaAccionIndicadores.invalid) {
      if (this.formLineaAccionIndicadores.value.idSprIndicador == null) {
        this.indicadorService.create(this.formLineaAccionIndicadores.value).subscribe(
          (resp) => {
            this.initApp(this.lineaAccion)
            this.modal.close();
            this.alert.createOk();
          },
          (err) => {
            this.alert.createError();
          }
        );
      } else {
        this.indicadorService.update(this.formLineaAccionIndicadores.value).subscribe(
          (resp) => {
            this.initApp(this.lineaAccion)
            this.modal.close();
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
      return;
    }
  }


  /////////////TRAE DATOS TIPO PARTICIPANTE///////////
  listTipoParticipante() {
    this.comunService.list().subscribe(resp => {
      this.dataTipoParticipante = this.getDataDependiente(resp, this.idTipoParticipante);
    })
  }
  //////////////DEPENDIENTE DEL CATALOGO COMUN///////////////////////////////
  getDataDependiente(dataObj: any, spr_idSprComun: any = null) {
    let stateOptionTipo = false;
    let dependientes: any = [];
    dataObj.forEach((row: any) => {
      if (row.spr_idSprComun == spr_idSprComun) {
        dependientes.push(
          {
            idSprComun: row.idSprComun,
            nombre: row.nombre,
            descripcion: row.descripcion,
            spr_idSprComun: row.spr_idSprComun,
            estado: row.estado,
          });
      }
    });
    return dependientes;
  }


  get appForm() {
    return this.formLineaAccionIndicadores.controls;
  }

  delete(row: any) {
    this.idDeleteRegister = row.idSprIndicador;
    this.modal.open('delete-lineaAccion');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.indicadorService.update({
        "idSprIndicador": this.idDeleteRegister,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      }).subscribe(resp => {
        this.initApp(this.lineaAccion)
        this.alert.deleteOk();
        this.modal.close();
      }, (err) => {
        this.alert.deleteError();
        this.modal.close();
      });
    }
  }
  configuracionInit(obj: any) {
    this.descripcionIndicador = obj.nombre;
    this.dataIndicadorSendConfig = obj;
    this.openModalAdverso();
  }

  edit(obj: any, row: any) {
    this.nombreLineaAccion = row.nombreLineaAccion;
    this.onResetForm();
    this.setFormLineaAccion(obj.idSprLineaAccion)
    this.formLineaAccionIndicadores.patchValue({
      idSprLineaAccion: obj.idSprLineaAccion,
      idSprIndicador: obj.idSprIndicador,
      idSprEquipoGerencial: obj.idSprResponsable,
      idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      unidadInformacion: obj.unidadInformacion,
      fechaInicio: obj.fechaInicio,
      estado: obj.estado,
    });
    this.modal.open(this.nameModal);
  }



  ConfguracionLineaAccion(obj: any) {
    this.desripcionLineaAccion = obj.nombreLineaAccion;

  }

  onResetForm() {
    this.submitted = false;
    this.formLineaAccionIndicadores.reset();
  }

  /****
   * Método para calcular el peso segun la ponderacion de cada indicador
   * 
   * ***/
  procesarPeso(listaIndicadores: any) {
    let dataInidcadorConfig: any[] = []
    listaIndicadores.forEach((elemento) => {
      this.configuracionIndicadoresService.list("?idSprIndicador=" + elemento.idSprIndicador).subscribe(
        (res: any) => {
          dataInidcadorConfig.push(...res)
          this.calcularPeso(listaIndicadores, dataInidcadorConfig)
        }
      )
    }
    )
    this.dataInidcadorConfig = dataInidcadorConfig
    //this.getConfigIndicadore(listaIndicadores, dataInidcadorConfig)

  }
  calcularPeso(listaIndicadores: any, dataInidcadorConfig) {
    if (dataInidcadorConfig.length == listaIndicadores.length) {

    } else {

    }
  }


  /**
   * 
   * FIN del método procesarPeso
   */

  openModal(row: any) {
    this.onResetForm();
    this.setFormLineaAccion(row.idSprLineaAccion);
    this.nombreLineaAccion = row.nombreLineaAccion;
    this.modal.open(this.nameModal);
  }
  openModalAdverso() {
    this.onResetForm();
    this.modal.open(this.modalAdversoLinea);
  }

  closeModalConfiguracion() {
    this.modal.closeId('objetivo-modalNewEdit');
  }

}
